import React, { useEffect } from "react";
import SigmaEmbed from "./SigmaEmbed";

export default function SigmaRouter({ content, config, setError }) {
  useEffect(() => {
    if (!config?.provider) {
      setError("Provider type does not exist.");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config?.provider]);

  return <>{config?.type === "IFRAME_EMBED" && <SigmaEmbed content={content} />}</>;
}
